import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const ProjectManagementPage = lazy(() => import('@/pages/projects/ProjectManagementPage'));
const TaskManagementPage = lazy(() => import('@/pages/projects/TaskManagementPage'));
const TaskCalendarPage = lazy(() => import('@/pages/projects/TaskCalendarPage'));
const ProjectGanttPage = lazy(() => import('@/pages/projects/ProjectGanttPage'));
const ProjectReportPage = lazy(() => import('@/pages/projects/ProjectReportPage'));
const ProjectRoadmapPage = lazy(() => import('@/pages/projects/ProjectRoadmapPage'));
const ProjectFilesPage = lazy(() => import('@/pages/projects/ProjectFilesPage'));
const ProjectCostDashboardPage = lazy(() => import('@/pages/projects/ProjectCostDashboardPage'));

/** 프로젝트 모듈 라우트 */
const projectRoutes = [
  <Route
    key="projects-list"
    path="projects/list"
    element={<PrivateRoute menuCode={MENU.PRJ_LIST}><ProjectManagementPage /></PrivateRoute>}
  />,
  <Route
    key="projects-tasks"
    path="projects/tasks"
    element={<PrivateRoute menuCode={MENU.PRJ_TASK}><TaskManagementPage /></PrivateRoute>}
  />,
  <Route
    key="projects-calendar"
    path="projects/calendar"
    element={<PrivateRoute menuCode={MENU.PRJ_CALENDAR}><TaskCalendarPage /></PrivateRoute>}
  />,
  // 간트차트는 기존과 동일하게 '프로젝트' 권한을 따른다.
  // (칸트차트 메뉴 자체의 권한으로 바꾸면 기존 사용자가 접근을 잃을 수 있어 유지)
  <Route
    key="projects-gantt"
    path="projects/gantt"
    element={<PrivateRoute menuCode={MENU.PRJ_GANTT}><ProjectGanttPage /></PrivateRoute>}
  />,
  <Route
    key="project-reports"
    path="project/reports"
    element={<PrivateRoute menuCode={MENU.PRJ_REPORT}><ProjectReportPage /></PrivateRoute>}
  />,
  <Route
    key="projects-roadmap"
    path="projects/roadmap"
    element={<PrivateRoute menuCode={MENU.PRJ_ROADMAP}><ProjectRoadmapPage /></PrivateRoute>}
  />,
  <Route
    key="projects-files"
    path="projects/filepages"
    element={<PrivateRoute menuCode={MENU.PRJ_FILE}><ProjectFilesPage /></PrivateRoute>}
  />,
  <Route
    key="projects-cost"
    path="projects/cost"
    element={<PrivateRoute menuCode={MENU.PRJ_COST}><ProjectCostDashboardPage /></PrivateRoute>}
  />,
];

export default projectRoutes;
